import React, {
  useEffect,
  useState
} from "react";

import axios from "axios";

import Header from "../components/Header";

import config from "../config";

const API =
  `${config.API_BASE_URL}/api/orders/my`;

const ITEMS_API =
  `${config.API_BASE_URL}/api/orders`;

const STATUS_FLOW = [
  "Pending",
  "Processing",
  "Shipped",
  "Delivered"
];

const MyOrders = () => {

  const [orders, setOrders] = useState([]);

  const [loading, setLoading] =
    useState(true);

  const [openOrder, setOpenOrder] =
    useState(null);

  const [items, setItems] =
    useState([]);

  const token =
    localStorage.getItem("token");

  // =========================
  // LOAD MY ORDERS
  // =========================
  const loadOrders = async () => {

    try {

      setLoading(true);

      const res = await axios.get(
        API,
        {
          headers: {
            Authorization:
              `Bearer ${token}`
          }
        }
      );

      setOrders(
        res.data.data || []
      );

    } catch (err) {

      console.error(
        "LOAD ORDERS ERROR:",
        err
      );

    } finally {

      setLoading(false);
    }
  };

  // =========================
  // LOAD ORDER ITEMS
  // =========================
  const loadItems = async (
    orderId
  ) => {

    try {

      const res = await axios.get(
        `${ITEMS_API}/${orderId}/items`,
        {
          headers: {
            Authorization:
              `Bearer ${token}`
          }
        }
      );

      setItems(
        res.data.data || []
      );

    } catch (err) {

      console.error(
        "LOAD ITEMS ERROR:",
        err
      );
    }
  };

  // =========================
  // OPEN DETAILS
  // =========================
  const openDetails = async (
    order
  ) => {

    setOpenOrder(order);

    await loadItems(order.id);
  };

  // =========================
  // INITIAL LOAD
  // =========================
  useEffect(() => {

    loadOrders();

  }, []);

  // =========================
  // STATUS STEP
  // =========================
  const getStep = (status) => {

    return STATUS_FLOW.indexOf(
      status
    );
  };

  return (

    <div style={styles.page}>

      <Header />

      <div style={styles.container}>

        <h1 style={styles.title}>
          📦 My Orders
        </h1>

        {loading ? (

          <div style={styles.box}>
            Loading orders...
          </div>

        ) : orders.length === 0 ? (

          <div style={styles.box}>
            No orders found
          </div>

        ) : (

          <div style={styles.grid}>

            {orders.map((o) => {

              const step =
                getStep(
                  o.status || "Pending"
                );

              return (

                <div
                  key={o.id}
                  style={styles.card}
                >

                  <div style={styles.cardTop}>

                    <div>

                      <h3>
                        Order #{o.id}
                      </h3>

                      <p style={styles.date}>
                        {
                          new Date(
                            o.createdat
                          ).toLocaleDateString()
                        }
                      </p>

                    </div>

                    <div style={{
                      ...styles.badge,
                      background:
                        o.status ===
                        "Delivered"
                          ? "#d4edda"
                          : "#fff3cd"
                    }}>
                      {o.status}
                    </div>

                  </div>

                  <div style={styles.total}>
                    ₹
                    {Number(
                      o.totalamount || 0
                    ).toFixed(2)}
                  </div>

                  {/* TRACKER */}

                  <div style={styles.track}>

                    {STATUS_FLOW.map(
                      (s, i) => (

                        <div
                          key={s}
                          style={styles.step}
                        >

                          <div
                            style={{
                              ...styles.dot,
                              background:
                                i <= step
                                  ? "#28a745"
                                  : "#ddd"
                            }}
                          />

                          <span
                            style={styles.stepLabel}
                          >
                            {s}
                          </span>

                        </div>
                      )
                    )}

                  </div>

                  <button
                    style={styles.btn}
                    onClick={() =>
                      openDetails(o)
                    }
                  >
                    View Details
                  </button>

                </div>
              );
            })}

          </div>
        )}

      </div>

      {/* ========================= */}
      {/* ORDER DETAILS */}
      {/* ========================= */}

      {openOrder && (

        <div style={styles.overlay}>

          <div style={styles.modal}>

            <div style={styles.modalHead}>

              <h2>
                Order #
                {openOrder.id}
              </h2>

              <button
                style={styles.closeBtn}
                onClick={() =>
                  setOpenOrder(null)
                }
              >
                ✕
              </button>

            </div>

            <div>

              {items.map((i) => (

                <div
                  key={i.id}
                  style={styles.item}
                >

                  <div>

                    <h4>
                      {i.name}
                    </h4>

                    <p>
                      Qty:
                      {" "}
                      {i.quantity}
                    </p>

                  </div>

                  <div>
                    ₹
                    {Number(
                      i.price
                    ).toFixed(2)}
                  </div>

                </div>
              ))}

            </div>

          </div>

        </div>
      )}

    </div>
  );
};

export default MyOrders;

// =========================
// STYLES
// =========================

const styles = {

  page: {
    background: "#f5f7fb",
    minHeight: "100vh"
  },

  container: {
    padding: 20
  },

  title: {
    marginBottom: 20
  },

  box: {
    background: "#fff",
    padding: 40,
    borderRadius: 12,
    textAlign: "center"
  },

  grid: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit,minmax(320px,1fr))",
    gap: 20
  },

  card: {
    background: "#fff",
    borderRadius: 16,
    padding: 20,
    boxShadow:
      "0 4px 12px rgba(0,0,0,0.08)"
  },

  cardTop: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 15
  },

  date: {
    color: "#666",
    fontSize: 13
  },

  badge: {
    padding: "8px 14px",
    borderRadius: 30,
    fontWeight: "bold"
  },

  total: {
    fontSize: 28,
    fontWeight: "bold",
    marginBottom: 20,
    color: "#ff5722"
  },

  track: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 20
  },

  step: {
    textAlign: "center",
    flex: 1
  },

  dot: {
    width: 14,
    height: 14,
    borderRadius: "50%",
    margin: "0 auto 8px"
  },

  stepLabel: {
    fontSize: 12
  },

  btn: {
    width: "100%",
    padding: 12,
    border: "none",
    background: "#ff9800",
    color: "#fff",
    borderRadius: 10,
    fontWeight: "bold",
    cursor: "pointer"
  },

  overlay: {
    position: "fixed",
    inset: 0,
    background:
      "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 20
  },

  modal: {
    width: "100%",
    maxWidth: 600,
    background: "#fff",
    borderRadius: 16,
    padding: 20
  },

  modalHead: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 20
  },

  closeBtn: {
    border: "none",
    background: "#dc3545",
    color: "#fff",
    borderRadius: 8,
    padding: "8px 12px",
    cursor: "pointer"
  },

  item: {
    display: "flex",
    justifyContent: "space-between",
    padding: "12px 0",
    borderBottom:
      "1px solid #eee"
  }
};